// storeFormSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StoreModesArray } from "../types/modules/store/storeModes.type";

interface NameLang {
  languageCode: string;
  name: string;
}

interface OpeningHour {
  day: string;
  openTime: string | null;
  closeTime: string | null;
}

interface PickupMethods {
  in_store: boolean;
  drive_thru: boolean;
}

interface StoreFormState {
  id: number | null;
  modes: StoreModesArray;
  commercialRegister: string | null;
  taxNumber: string | null;
  city: string;
  name: NameLang[];
  phone: string;
  lat: number | null;
  lng: number | null;
  type: number[]; // changed from number | null
  subTypeIds: number[];
  sectorId: number | null;
  pickupMethods: PickupMethods;
  openingHours: OpeningHour[];
  logo: File | null;
  commercialRegisterFile: File | null;
  taxNumberFile: File | null;
  coverImage: File | null;
  phoneLogin: string;
  password: string;
}

const initialState: StoreFormState = {
  id: null,
  modes: ["order"],
  commercialRegister: "",
  taxNumber: "",
  city: "",
  name: [],
  phone: "",
  lat: null,
  lng: null,
  subTypeIds: [],
  sectorId: null,
  type: [],
  pickupMethods: { in_store: true, drive_thru: true },
  openingHours: [
    { day: "sun", openTime: "", closeTime: "" },
    { day: "mon", openTime: "", closeTime: "" },
    { day: "tue", openTime: "", closeTime: "" },
    { day: "wed", openTime: "", closeTime: "" },
    { day: "thu", openTime: "", closeTime: "" },
    { day: "fri", openTime: "", closeTime: "" },
    { day: "sat", openTime: "", closeTime: "" },
  ],
  logo: null,
  coverImage: null,
  taxNumberFile: null,
  commercialRegisterFile: null,
  phoneLogin: "",
  password: "",
};

const storeFormSlice = createSlice({
  name: "storeForm",
  initialState,
  reducers: {
    updateForm(state, action: PayloadAction<Partial<StoreFormState>>) {
      return { ...state, ...action.payload };
    },
    resetStoreForm() {
      return initialState;
    },
    setStoreId(state, action: PayloadAction<Partial<{ id: number }>>) {
      if (action.payload.id !== undefined) {
        if (action.payload.id !== state.id) {
          return { ...initialState, id: action.payload.id };
        }
      }
    },
  },
});

export const { updateForm, resetStoreForm, setStoreId } =
  storeFormSlice.actions;
export default storeFormSlice.reducer;
